const firebaseConfig = {
        apiKey: "AIzaSyCy0Pcrn2hAZGnN9MNwoTHwQTgmaMGraUg",
  authDomain: "sigma-travel.firebaseapp.com",
  projectId: "sigma-travel",
  storageBucket: "sigma-travel.appspot.com",
  messagingSenderId: "183333688777",
  appId: "1:183333688777:web:e8793842a445780725c418"
        
};
export default firebaseConfig;